import { GAUGE_DEFAULT_CONFIG } from '../constants.js';
import { applyThresholdDefaults } from './apply-threshold-default.js';
import { isValidColorRule } from '../../core/slots/ColorRule.js';
import { baseToolbarProps } from '../../core/slots/toolbar/CompactToolbar.js';
import type { GaugeChartInternalConfig } from '../types/gauge-chart-config-internal.js';
import type {
  GaugeChartConsumerConfig,
  GaugeChartSlotsConfig,
} from '../types/gauge-chart-config.js';
import type { GaugeChartProps } from '../types/gauge-chart.js';

export const buildGaugeChartConfig = (
  props: GaugeChartProps,
  consumerConfig: GaugeChartConsumerConfig,
  slots: GaugeChartSlotsConfig,
): GaugeChartInternalConfig => {
  const min = props.min ?? consumerConfig.min ?? GAUGE_DEFAULT_CONFIG.min;
  const max = props.max ?? consumerConfig.max ?? GAUGE_DEFAULT_CONFIG.max;
  const color =
    props.color ?? consumerConfig.color ?? GAUGE_DEFAULT_CONFIG.color;
  const formatter = props.formatter ?? consumerConfig.formatter;
  const loading =
    props.loading ?? consumerConfig.loading ?? GAUGE_DEFAULT_CONFIG.loading;
  const showThresholdIndicators =
    props.showThresholdIndicators ??
    consumerConfig.showThresholdIndicators ??
    GAUGE_DEFAULT_CONFIG.showThresholdIndicators;

  const thresholdsIndicators =
    slots.thresholdsIndicators.length === 0
      ? consumerConfig.thresholdsIndicators?.map(applyThresholdDefaults)
      : slots.thresholdsIndicators;
  const colorRules = (consumerConfig.colorRules || [])
    .filter(isValidColorRule)
    .concat(slots.colorRules || []);

  const toolbar = {
    ...baseToolbarProps(),
    ...consumerConfig.toolbar,
    ...slots.toolbar,
  };

  const tooltip =
    slots.tooltip ?? consumerConfig.tooltip ?? GAUGE_DEFAULT_CONFIG.tooltip;

  const valueAccessor = props.valueAccessor ?? consumerConfig.valueAccessor;

  const unit = props.unit ?? consumerConfig.unit;

  return {
    min,
    max,
    color,
    formatter,
    thresholdsIndicators,
    showThresholdIndicators,
    labelSlot: slots.label,
    colorRules,
    toolbar,
    tooltip,
    intents: slots.intents,
    valueAccessor,
    unit,
    loading,
  };
};
